export default __webpack_public_path__ + "static/media/case2-1 (3).516b0e58.png";